import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { TemplateComponent } from './components/template/template.component';
import { AuthGuard } from './guards/auth.guard';
import { LogoutComponent } from './components/logout/logout.component';
import { HomeComponent } from './components/home/home.component';
import { LandingpageoutsideloginComponent } from './components/landingpageoutsidelogin/landingpageoutsidelogin.component';
import { AdminComponent } from './components/admin/admin.component';
import { LandingPageComponent } from './components/landing-page/landing-page.component';

const routes: Routes = [
  { path: '', component: LandingPageComponent },

  {
    path: 'public-documents/:tabName', component: LandingpageoutsideloginComponent,
  },
  {
    path: 'private-documents/oss&thirdpartynotices', redirectTo: 'login', pathMatch: 'full'
  },

  { path: 'login', component: LoginComponent },

  {
    path: '', component: TemplateComponent, canActivate: [AuthGuard],
    children: [
      { path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
      { path: 'administration', component: AdminComponent },

    ]
  },
  {
    path: 'public-documents', component: LandingpageoutsideloginComponent,
  },
  { path: 'logged-out', component: LogoutComponent },
  { path: '**', redirectTo: '/login' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, scrollOffset: [0, 80] })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
